import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from './UserContext';

const setupRoutes = new Set(['/create-profile', '/login', '/terms', '/privacy', '/child-safety']);

export default function ProfileSetupGate({ children }) {
  const { profileStatus } = useContext(UserContext);
  const { pathname } = useLocation();
  if (profileStatus === 'missing' && !setupRoutes.has(pathname)) {
    return <Navigate to="/create-profile" replace />;
  }
  return children;
}
